import { useRefGetter, useUpdate } from '@bydesign-ui/hooks';
import { useContext, useEffect } from 'react';
import { NotificationContext } from '../context/notification';
export function useNoticeList(placement) {
  var update = useUpdate();
  var notification = useContext(NotificationContext);
  var placementGetter = useRefGetter(placement);

  if (notification == null) {
    throw new Error('use useNoticeList not in NotificationContext');
  }

  useEffect(function () {
    var callback = function callback(updatedPlacement) {
      if (updatedPlacement === placementGetter()) {
        update();
      }
    };

    notification.addListener('change', callback);
    return function () {
      notification.removeListener('change', callback);
    };
  }, [notification]);
  return notification.getNotices(placement);
}